// plugins/pinia-persisted-state.ts
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

export default defineNuxtPlugin((nuxtApp) => {
  // Get the pinia instance
  const pinia = nuxtApp.$pinia
  
  // Apply the plugin to pinia
  if (pinia) {
    (pinia as any).use(piniaPluginPersistedstate)
  }
}) 